import Calendar from '../store/schema/Calendar';
import CalendarEntryExtended from '../store/schema/CalendarGroupExtended';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import CalendarId from '../store/schema/CalendarId';
import ItemId from 'owa-service/lib/contract/ItemId';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import { action } from 'satcheljs';
import { MailboxInfo } from 'owa-client-ids';
import CalendarGroupExtended from '../store/schema/CalendarGroupExtended';
import { CalendarCacheScenarioId } from '../store/schema/CalendarCacheScenarioId';

export const initializeCalendarsCacheInStore = action(
    'initializeCalendarsCacheInStore',
    (
        defaultCalendarEntry: Calendar,
        calendarEntries: { [key: string]: CalendarEntryExtended },
        calendarFolders: { [key: string]: CalendarFolder },
        calendarGroups: { [key: string]: CalendarGroupExtended },
        folderIdMapping: { [key: string]: CalendarId },
        calendarIdToChangeKeyMapping: { [key: string]: string }
    ) => {
        return {
            defaultCalendarEntry,
            calendarEntries,
            calendarFolders,
            calendarGroups,
            folderIdMapping,
            calendarIdToChangeKeyMapping,
        };
    }
);

export const calendarCacheInitializeFailed = action(
    'calendarCacheInitializeFailed',
    (calendarCacheScenarioId: CalendarCacheScenarioId, mailboxId?: string) => ({
        calendarCacheScenarioId,
        mailboxId,
    })
);

export const initializeCalendarsCache = action(
    'initializeCalendarsCache',
    (calendarCacheScenarioId: CalendarCacheScenarioId, isPrimaryAccount: boolean = true) => ({
        calendarCacheScenarioId,
        isPrimaryAccount,
    })
);

export const calendarCacheInitialized = action(
    'calendarCacheInitialized',
    (calendarCacheScenarioId: CalendarCacheScenarioId, mailboxId?: string) => ({
        calendarCacheScenarioId,
        mailboxId,
    })
);

export const updateChangeKeyByCalendarItemId = action(
    'updateChangeKeyByCalendarItemId',
    (itemId: ItemId) => ({ itemId })
);

export const addToCalendarsCache = action(
    'addToCalendarsCache',
    (
        calendarEntry: CalendarEntry | LocalCalendarEntry,
        folder: CalendarFolder,
        mailboxInfo: MailboxInfo
    ) => {
        return {
            calendarEntry,
            folder,
            mailboxInfo,
        };
    }
);

export const addCalendarGroupToCalendarsCache = action(
    'addCalendarGroupToCalendarsCache',
    (calendarGroup: CalendarGroupExtended) => {
        return {
            calendarGroup,
        };
    }
);

export const updateCalendarEntry = action(
    'updateCalendarEntry',
    (itemId: ItemId, calendarEntry: Partial<CalendarEntry>) => ({ itemId, calendarEntry })
);

export const updateCalendarFolder = action(
    'updateCalendarFolder',
    (calendar: Calendar, calendarFolder: Partial<CalendarFolder>) => ({ calendar, calendarFolder })
);

export const removeCalendarFromCalendarsCache = action(
    'removeCalendarFromCalendarsCache',
    (calendar: Calendar) => ({ calendar })
);

export const markCalendarEntryAsValid = action(
    'markCalendarEntryAsValid',
    (calendarEntry: CalendarEntry) => ({ calendarEntry })
);

export const calendarUpdated = action(
    'calendarUpdated',
    (calendarId: string, updates: Partial<Calendar>) => ({ calendarId, updates })
);
